//Proofed
import { Box, Container, Stack, Typography } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { FancyGoldButton } from './FancyGoldButton'
import { FancyLightButton } from './FancyLightButton'
import { COLOR_PRIMARY, NAVBAR_BG, DARK_800, SECTION_DARK, BG_LIGHT } from '../theme'
import { WaveDivider } from './WaveDivider'

interface CtaSectionProps {
    title?: string
    subtitle?: string
    demobutton?: string
    showJoinButton?: boolean
    onDemoClick: () => void
}

export function CtaSection({
    title = 'Ready to build your public sector pipeline?',
    subtitle = 'Start your 14-day free trial today. Full access, no commitment.',
    demobutton = 'Book a Demo',
    showJoinButton = true,
    onDemoClick,
}: CtaSectionProps) {
    return (
        <>
            <WaveDivider top={BG_LIGHT} bottom={DARK_800} />
            <Box sx={{
                background: `linear-gradient(135deg, ${NAVBAR_BG} 0%, ${DARK_800} 100%)`,
                ...SECTION_DARK,
                textAlign: 'center',
            }}>

                <Container maxWidth="sm">
                    <Typography variant="h2" sx={{ color: 'white', mb: 2 }}>{title}</Typography>
                    <Typography sx={{ color: 'rgba(255,255,255,0.6)', mb: 5, fontSize: '18px', lineHeight: 1.7 }}>
                        {subtitle}
                    </Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
                        {showJoinButton && <FancyGoldButton to="/register" color={COLOR_PRIMARY} endIcon={<ArrowForwardIcon />}>
                            Join free for 14 days
                        </FancyGoldButton>}
                        <FancyLightButton onClick={onDemoClick} color={COLOR_PRIMARY}>
                            {demobutton}
                        </FancyLightButton>
                    </Stack>
                </Container>
            </Box>
        </>
    )
}
